const isEnabledValue = (value) => value === true || value === 1 || value === "1";

export const normalizeEmergencyServerState = (response, collectionKey) => {
  const payload = response && typeof response === "object" ? response : {};
  const document = payload.document && typeof payload.document === "object"
    ? payload.document
    : {};
  const data = Array.isArray(document[collectionKey]) ? document[collectionKey] : [];
  const toggleValue = payload.toggle !== undefined ? payload.toggle : document.toggle;
  const toggle = isEnabledValue(toggleValue);
  const disabledValue = payload.disabled !== undefined ? payload.disabled : document.disabled;
  const existsValue = payload.exists !== undefined ? payload.exists : document.exists;
  const normalizedState = {
    loading: false,
    error: payload.error || null,
    exists: isEnabledValue(existsValue),
    disabled: disabledValue === true,
    toggle,
    version: payload.version !== undefined ? payload.version : document.version,
    internal_revision_id: payload.internal_revision_id !== undefined
      ? payload.internal_revision_id
      : document.internal_revision_id,
    status: payload.status !== undefined ? payload.status : document.status,
    data
  };

  if (collectionKey === "questions") {
    return {
      ...normalizedState,
      questions: data,
      headingContents: document.heading_contents && typeof document.heading_contents === "object"
        ? document.heading_contents
        : {}
    };
  }

  return normalizedState;
};

export const getEmergencyPlanOptions = (plans = []) => (Array.isArray(plans) ? plans : []).map((plan = {}) => {
  const source = plan.source && typeof plan.source === "object" ? plan.source : {};
  const value = plan.plan_id !== undefined
    ? plan.plan_id
    : (plan.id !== undefined ? plan.id : (plan.document_number || source.plan_id));
  const label = plan.title || plan.plan_name || plan.name || source.plan_name || source.title
    || (value !== undefined && value !== null ? `Emergency Plan ${value}` : "");

  return { value, label };
}).filter((option) => option.value !== undefined && option.value !== null);

export const mapEmergencyReadinessQuestions = (questions = [], planOptions = []) => (Array.isArray(questions) ? questions : []).map((question = {}) => {
  const planId = question.emergency_plan_id;
  const matchedPlan = Array.isArray(planOptions) ? planOptions.find((option) => planId != null && String(option.value) === String(planId)) : null;
  return matchedPlan ? { ...question, plan_name: matchedPlan.label } : question;
});
